import { useState } from 'react';

export default function HandymanFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much do handyman services cost in El Paso?',
      answer: 'Handyman rates in El Paso typically range from $50-$100 per hour, depending on the complexity of work and experience level. Some handymen charge flat rates for specific projects. Small repairs may cost $100-$300, while larger projects can range from $500-$2,000. Always get written estimates before work begins.'
    },
    {
      question: 'Do handymen in El Paso need to be licensed?',
      answer: 'In Texas, handymen don\'t need a state license for small jobs under $5,000. However, they should have general liability insurance and workers compensation. For specialized work like electrical or plumbing, licensed contractors may be required. Always verify insurance coverage before hiring.'
    },
    {
      question: 'What\'s the difference between a handyman and a contractor?',
      answer: 'Handymen handle small repairs and maintenance tasks, typically projects under $5,000. Contractors are licensed for specific trades (electrical, plumbing, HVAC) and handle larger, more complex projects requiring permits. For major renovations or specialized work, hire a licensed contractor.'
    },
    {
      question: 'How do I find a reliable handyman in El Paso?',
      answer: 'Check online reviews, ask for references, verify insurance coverage, and get multiple quotes. Look for handymen with experience in your specific project type. Professional handymen should provide written estimates, communicate clearly, and arrive on time with proper tools.'
    },
    {
      question: 'What services can a handyman legally perform in Texas?',
      answer: 'Handymen can perform general repairs, painting, drywall work, minor plumbing fixes, furniture assembly, and basic carpentry. They cannot perform work requiring specialized licenses like major electrical work, HVAC installation, or structural modifications. Projects over $5,000 may require licensed contractors.'
    },
    {
      question: 'Should I provide materials or will the handyman?',
      answer: 'This varies by handyman and project. Some include materials in their quote, while others prefer you purchase materials. Discuss this upfront to avoid confusion. If the handyman purchases materials, expect a markup. Providing your own materials may save money but requires knowing exactly what\'s needed.'
    },
    {
      question: 'How long do typical handyman projects take?',
      answer: 'Small repairs like fixing a leaky faucet or hanging pictures take 1-2 hours. Medium projects like painting a room or assembling furniture take 3-6 hours. Larger projects like deck repairs or multiple room painting can take 1-3 days. Your handyman should provide a time estimate with the quote.'
    },
    {
      question: 'What should I ask before hiring a handyman?',
      answer: 'Ask about insurance coverage, experience with your specific project, hourly rates or project pricing, estimated timeline, and whether they provide warranties. Request references and check online reviews. Ensure they provide written estimates and clear communication about project scope and costs.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Common questions about handyman services in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-emerald-50 to-white rounded-xl border-2 border-emerald-100 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-emerald-50 transition-colors"
              >
                <h4 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-emerald-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
